import { logger } from '../logger';

/**
 * Logger for UI-related events
 * Use this for user interactions, component lifecycle, and UI errors
 */
const uiLogger = logger.child('UI');

export default uiLogger;
